module.exports = __webpack_public_path__ + "img/VirtualCapabilities_00478.baf82f13.jpg";